<app-tabla
  [totalCount]="totalCount"
  [datos]="modelosDispositivos"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [crear]="botonCrear"
  [filtros]="filtros"
  [emptyState]="{ title: 'Todavía no hay modelos' }"
></app-tabla>
